export default __webpack_public_path__ + "static/banner-portal-0844cd005fa1145701e52b69917aeecc.webp";